import { CornerFiller, EndPanel, Filler, RearPanel } from '../__generated/model/index.js'
import { CabinetWidth } from '../implementations/common.js'

export const rearPanelSizes = [
  CabinetWidth.W18,
  CabinetWidth.W24,
  CabinetWidth.W30,
  CabinetWidth.W36,
  CabinetWidth.W42,
  CabinetWidth.W48,
  CabinetWidth.W54,
  CabinetWidth.W60,
  CabinetWidth.W66,
  CabinetWidth.W72,
  CabinetWidth.W78,
  CabinetWidth.W84,
  CabinetWidth.W90,
  CabinetWidth.W96,
]

export const partData = {
  [`${CornerFiller.type}`]: {
    name: 'Corner Filler',
    sku: 'LYNX-P-CFIL-3.5x3.5',
    description: 'Lynx Rise 3-1/2" x 3-1/2" L|R Width Corner Filler',
  },

  [`${EndPanel.type}_${CabinetWidth.W28_25}`]: {
    name: '1"W End Panel 28-1/4"D',
    sku: 'LYNX-P-RSE-FEP-28.25',
    description: 'Lynx Rise 1"W End Panel 28-1/4"D',
  },
  [`${EndPanel.type}_${CabinetWidth.W29_25}`]: {
    name: '1"W End Panel 29-1/4"D',
    sku: 'LYNX-P-RSE-FEP-29.25',
    description: 'Lynx Rise 1"W End Panel 29-1/4"D',
  },

  [`${RearPanel.type}_${CabinetWidth.W18}`]: {
    name: '18"W Flat Rear Panel',
    sku: 'LYNX-P-RSE-FRP-18',
    description: 'Lynx Rise 18"W Flat Finished Rear Panel',
  },
  [`${RearPanel.type}_${CabinetWidth.W24}`]: {
    name: '24"W Flat Rear Panel',
    sku: 'LYNX-P-RSE-FRP-24',
    description: 'Lynx Rise 24"W Flat Finished Rear Panel',
  },
  [`${RearPanel.type}_${CabinetWidth.W30}`]: {
    name: '30"W Flat Rear Panel',
    sku: 'LYNX-P-RSE-FRP-30',
    description: 'Lynx Rise 30"W Flat Finished Rear Panel',
  },
  [`${RearPanel.type}_${CabinetWidth.W36}`]: {
    name: '36"W Flat Rear Panel',
    sku: 'LYNX-P-RSE-FRP-36',
    description: 'Lynx Rise 36"W Flat Finished Rear Panel',
  },
  [`${RearPanel.type}_${CabinetWidth.W42}`]: {
    name: '42"W Flat Rear Panel',
    sku: 'LYNX-P-RSE-FRP-42',
    description: 'Lynx Rise 42"W Flat Finished Rear Panel',
  },
  [`${RearPanel.type}_${CabinetWidth.W48}`]: {
    name: '48"W Flat Rear Panel',
    sku: 'LYNX-P-RSE-FRP-48',
    description: 'Lynx Rise 48"W Flat Finished Rear Panel',
  },
  [`${RearPanel.type}_${CabinetWidth.W54}`]: {
    name: '54"W Flat Rear Panel',
    sku: 'LYNX-P-RSE-FRP-54',
    description: 'Lynx Rise 54"W Flat Finished Rear Panel',
  },
  [`${RearPanel.type}_${CabinetWidth.W60}`]: {
    name: '60"W Flat Rear Panel',
    sku: 'LYNX-P-RSE-FRP-60',
    description: 'Lynx Rise 60"W Flat Finished Rear Panel',
  },
  [`${RearPanel.type}_${CabinetWidth.W66}`]: {
    name: '66"W Flat Rear Panel',
    sku: 'LYNX-P-RSE-FRP-66',
    description: 'Lynx Rise 66"W Flat Finished Rear Panel',
  },
  [`${RearPanel.type}_${CabinetWidth.W72}`]: {
    name: '72"W Flat Rear Panel',
    sku: 'LYNX-P-RSE-FRP-76',
    description: 'Lynx Rise 72"W Flat Finished Rear Panel',
  },
  [`${RearPanel.type}_${CabinetWidth.W78}`]: {
    name: '78"W Flat Rear Panel',
    sku: 'LYNX-P-RSE-FRP-78',
    description: 'Lynx Rise 78"W Flat Finished Rear Panel',
  },
  [`${RearPanel.type}_${CabinetWidth.W84}`]: {
    name: '84"W Flat Rear Panel',
    sku: 'LYNX-P-RSE-FRP-84',
    description: 'Lynx Rise 84"W Flat Finished Rear Panel',
  },
  [`${RearPanel.type}_${CabinetWidth.W90}`]: {
    name: '90"W Flat Rear Panel',
    sku: 'LYNX-P-RSE-FRP-90',
    description: 'Lynx Rise 90"W Flat Finished Rear Panel',
  },
  [`${RearPanel.type}_${CabinetWidth.W96}`]: {
    name: '96"W Flat Rear Panel',
    sku: 'LYNX-P-RSE-FRP-96',
    description: 'Lynx Rise 96"W Flat Finished Rear Panel',
  },

  [`${Filler.type}_${CabinetWidth.W1}`]: {
    name: '1"W Filler Panel',
    sku: 'LYNX-P-RSE-FIL-1.00',
    description: 'Lynx Rise 1"W Filler Panel',
  },
  [`${Filler.type}_${CabinetWidth.W1_25}`]: {
    name: '1.25"W Filler Panel',
    sku: 'LYNX-P-RSE-FIL-1.25',
    description: 'Lynx Rise 1.25"W Filler Panel',
  },
  [`${Filler.type}_${CabinetWidth.W1_5}`]: {
    name: '1.5"W Filler Panel',
    sku: 'LYNX-P-RSE-FIL-1.50',
    description: 'Lynx Rise 1.5"W Filler Panel',
  },
  [`${Filler.type}_${CabinetWidth.W1_75}`]: {
    name: '1.75"W Filler Panel',
    sku: 'LYNX-P-RSE-FIL-1.75',
    description: 'Lynx Rise 1.75"W Filler Panel',
  },
  [`${Filler.type}_${CabinetWidth.W2}`]: {
    name: '2"W Filler Panel',
    sku: 'LYNX-P-RSE-FIL-2.00',
    description: 'Lynx Rise 2"W Filler Panel',
  },
  [`${Filler.type}_${CabinetWidth.W2_25}`]: {
    name: '2.25"W Filler Panel',
    sku: 'LYNX-P-RSE-FIL-2.25',
    description: 'Lynx Rise 2.25"W Filler Panel',
  },
  [`${Filler.type}_${CabinetWidth.W2_5}`]: {
    name: '2.5"W Filler Panel',
    sku: 'LYNX-P-RSE-FIL-2.50',
    description: 'Lynx Rise 2.5"W Filler Panel',
  },
  [`${Filler.type}_${CabinetWidth.W2_75}`]: {
    name: '2.75"W Filler Panel',
    sku: 'LYNX-P-RSE-FIL-2.75',
    description: 'Lynx Rise 2.75"W Filler Panel',
  },
  [`${Filler.type}_${CabinetWidth.W3}`]: {
    name: '3"W Filler Panel',
    sku: 'LYNX-P-RSE-FIL-3.00',
    description: 'Lynx Rise 3"W Filler Panel',
  },
  [`${Filler.type}_${CabinetWidth.W3_25}`]: {
    name: '3.25"W Filler Panel',
    sku: 'LYNX-P-RSE-FIL-3.25',
    description: 'Lynx Rise 3.25"W Filler Panel',
  },
  [`${Filler.type}_${CabinetWidth.W3_5}`]: {
    name: '3.5"W Filler Panel',
    sku: 'LYNX-P-RSE-FIL-3.50',
    description: 'Lynx Rise 3.5"W Filler Panel',
  },
  [`${Filler.type}_${CabinetWidth.W3_75}`]: {
    name: '3.75"W Filler Panel',
    sku: 'LYNX-P-RSE-FIL-3.75',
    description: 'Lynx Rise 3.75"W Filler Panel',
  },
  [`${Filler.type}_${CabinetWidth.W4}`]: {
    name: '4"W Filler Panel',
    sku: 'LYNX-P-RSE-FIL-4.00',
    description: 'Lynx Rise 4"W Filler Panel',
  },
  [`${Filler.type}_${CabinetWidth.W4_25}`]: {
    name: '4.25"W Filler Panel',
    sku: 'LYNX-P-RSE-FIL-4.25',
    description: 'Lynx Rise 4.25"W Filler Panel',
  },
  [`${Filler.type}_${CabinetWidth.W4_5}`]: {
    name: '4.5"W Filler Panel',
    sku: 'LYNX-P-RSE-FIL-4.50',
    description: 'Lynx Rise 4.5"W Filler Panel',
  },
  [`${Filler.type}_${CabinetWidth.W4_75}`]: {
    name: '4.75"W Filler Panel',
    sku: 'LYNX-P-RSE-FIL-4.75',
    description: 'Lynx Rise 4.75"W Filler Panel',
  },
  [`${Filler.type}_${CabinetWidth.W5}`]: {
    name: '5"W Filler Panel',
    sku: 'LYNX-P-RSE-FIL-5.00',
    description: 'Lynx Rise 5"W Filler Panel',
  },
} as const

export const endPanelWithBackPanel = partData[`${EndPanel.type}_${CabinetWidth.W28_25}`]!
export const endPanelWithoutBackPanel = partData[`${EndPanel.type}_${CabinetWidth.W29_25}`]!
export const cornerFiller = {
  name: 'Corner Filler',
  sku: 'LYNX-P-CFIL-3.5x3.5',
  description: 'Lynx Rise 3-1/2" x 3-1/2" L|R Width Corner Filler',
}

export const partDataBySku = Object.entries(partData).reduce<
  Record<string, { key: string; name: string; sku: string; description: string }>
>((acc, [key, item]) => {
  acc[item.sku] = {
    ...item,
    key,
  }

  return acc
}, {})
